import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, ChevronDown, Bell, TrendingDown, LogOut, LayoutGrid } from 'lucide-react';
import { useActivity } from '../lib/activityStore';
import { useAuth, openLogin } from '../lib/authStore';
import { PoweredByRTA } from './PoweredByRTA';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [bellOpen, setBellOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const {
    offers
  } = useActivity();
  const {
    user,
    signOut
  } = useAuth();
  const unreadOffers = offers.filter(o => o.unread);
  const navItems = [{
    name: 'Marketplace',
    path: '/marketplace'
  }, {
    name: 'My Jobs',
    path: '/activity'
  }];
  return <nav className="fixed top-0 left-0 right-0 z-50 glass-panel border-b border-gray-100/50" data-id="element-315">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-316">
        <div className="flex justify-between items-center h-20" data-id="element-317">
          <div className="flex items-center" data-id="element-318">
            <Link to="/" className="flex items-center gap-3" data-id="element-319">
              <img src="https://cdn.magicpatterns.com/uploads/kwTMidwDpg46YyVPyEcdAS/Pair2_(2).svg" alt="Pair2" className="h-9 w-auto" data-id="element-320" />
              <span className="font-display font-semibold text-lg tracking-tight text-gray-400 hidden sm:inline border-l border-gray-200 pl-3" data-id="element-321">
                Move
              </span>
            </Link>
            <div className="hidden lg:flex items-center pl-4 ml-3 border-l border-gray-200/70" data-id="element-322">
              <PoweredByRTA data-id="element-323" />
            </div>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-1" data-id="element-324">
            {navItems.map(item => <Link key={item.name} to={item.path} className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${location.pathname === item.path ? 'bg-brand-50 text-brand-600' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-325">
                {item.name}
              </Link>)}
          </div>

          <div className="hidden md:flex items-center space-x-4" data-id="element-326">
            <div className="relative" data-id="element-327">
              <button onClick={() => setBellOpen(v => !v)} className="p-2 text-gray-400 hover:text-gray-600 transition-colors relative" aria-label="Notifications" data-id="element-328">
                <Bell className="w-5 h-5" data-id="element-329" />
                {unreadOffers.length > 0 ? <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 bg-brand-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center border-2 border-white" data-id="element-330">
                    {unreadOffers.length}
                  </span> : <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-brand-500 rounded-full" data-id="element-331" />}
              </button>
              <AnimatePresence data-id="element-332">
                {bellOpen && <>
                    <div className="fixed inset-0 z-30" onClick={() => setBellOpen(false)} data-id="element-333" />
                    <motion.div initial={{
                  opacity: 0,
                  y: -6
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: -6
                }} className="absolute right-0 top-full mt-2 w-80 bg-white rounded-2xl shadow-xl border border-gray-100 z-40 overflow-hidden" data-id="element-334">
                      <div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between" data-id="element-335">
                        <p className="font-bold text-gray-900 text-sm" data-id="element-336">
                          Notifications
                        </p>
                        <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider" data-id="element-337">
                          {unreadOffers.length} new
                        </span>
                      </div>
                      <div className="max-h-80 overflow-y-auto" data-id="element-338">
                        {unreadOffers.length === 0 ? <div className="p-6 text-center text-xs text-gray-500" data-id="element-339">
                            You're all caught up.
                          </div> : unreadOffers.map(o => <button key={o.id} onClick={() => {
                      setBellOpen(false);
                      navigate('/activity', {
                        state: {
                          initialTab: 'offers'
                        }
                      });
                    }} className="w-full text-left px-4 py-3 hover:bg-gray-50 border-b border-gray-50 last:border-b-0 flex gap-3 items-start" data-id="element-340">
                              <div className="w-9 h-9 rounded-xl bg-brand-50 text-brand-600 flex items-center justify-center shrink-0" data-id="element-341">
                                <TrendingDown className="w-4 h-4" data-id="element-342" />
                              </div>
                              <div className="flex-1 min-w-0" data-id="element-343">
                                <p className="text-xs font-bold text-gray-900 truncate" data-id="element-344">
                                  {o.supplierName} countered: AED{' '}
                                  {o.currentPrice}
                                </p>
                                <p className="text-[11px] text-gray-500 truncate" data-id="element-345">
                                  {o.serviceName} · was AED {o.originalPrice}
                                </p>
                              </div>
                            </button>)}
                      </div>
                      <button onClick={() => {
                    setBellOpen(false);
                    navigate('/activity', {
                      state: {
                        initialTab: 'offers'
                      }
                    });
                  }} className="w-full px-4 py-2.5 bg-gray-50 hover:bg-gray-100 text-xs font-bold text-gray-700 text-center border-t border-gray-100 transition-colors" data-id="element-346">
                        View all in My Jobs →
                      </button>
                    </motion.div>
                  </>}
              </AnimatePresence>
            </div>
            {user ? <div className="relative pl-3 border-l border-gray-200" data-id="element-347">
                <button onClick={() => setUserMenuOpen(v => !v)} className="flex items-center gap-2 hover:bg-gray-50 rounded-full pl-1 pr-2 py-1 transition-colors" data-id="element-348">
                  <div className="w-8 h-8 rounded-full bg-gradient-to-br from-brand-500 to-orange-500 flex items-center justify-center text-white text-xs font-bold uppercase" data-id="element-349">
                    {user.name ? user.name.trim().charAt(0) : user.phone.replace(/\D/g, '').slice(-2)}
                  </div>
                  {user.name && <span className="hidden sm:inline text-sm font-semibold text-gray-700 max-w-[80px] truncate" data-id="element-350">
                      Hi, {user.name.split(' ')[0]}
                    </span>}
                  <ChevronDown className="w-4 h-4 text-gray-400" data-id="element-351" />
                </button>
                <AnimatePresence data-id="element-352">
                  {userMenuOpen && <>
                      <div className="fixed inset-0 z-30" onClick={() => setUserMenuOpen(false)} data-id="element-353" />
                      <motion.div initial={{
                  opacity: 0,
                  y: -6
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: -6
                }} className="absolute right-0 top-full mt-2 w-60 bg-white rounded-2xl shadow-xl border border-gray-100 z-40 overflow-hidden" data-id="element-354">
                        <div className="px-4 py-3 border-b border-gray-100" data-id="element-355">
                          <p className="text-[10px] uppercase tracking-wider font-bold text-gray-400" data-id="element-356">
                            Signed in
                          </p>
                          {user.name && <p className="font-semibold text-gray-900 text-sm leading-tight" data-id="element-357">
                              {user.name}
                            </p>}
                          <p className={`${user.name ? 'text-[11px] text-gray-500' : 'font-semibold text-gray-900 text-sm'}`} data-id="element-358">
                            {user.phone}
                          </p>
                        </div>
                        <button onClick={() => {
                    setUserMenuOpen(false);
                    navigate('/');
                  }} className="w-full text-left px-4 py-2.5 hover:bg-gray-50 flex items-center gap-2 text-sm text-gray-700" data-id="element-359">
                          <LayoutGrid className="w-4 h-4 text-gray-500" data-id="element-360" />{' '}
                          Switch portal
                        </button>
                        <button onClick={() => {
                    setUserMenuOpen(false);
                    signOut();
                    navigate('/');
                  }} className="w-full text-left px-4 py-2.5 hover:bg-gray-50 flex items-center gap-2 text-sm text-rose-600 border-t border-gray-50" data-id="element-361">
                          <LogOut className="w-4 h-4" data-id="element-362" /> Sign out
                        </button>
                      </motion.div>
                    </>}
                </AnimatePresence>
              </div> : <button onClick={() => openLogin()} className="ml-3 px-4 py-2 bg-gray-900 hover:bg-black text-white rounded-full text-sm font-semibold transition-colors" data-id="element-363">
                Sign in
              </button>}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-364">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-500 hover:text-gray-700 p-2" data-id="element-365">
              {isOpen ? <X className="w-6 h-6" data-id="element-366" /> : <Menu className="w-6 h-6" data-id="element-367" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="md:hidden bg-white border-t border-gray-100" data-id="element-368">
          <div className="px-4 pt-2 pb-4 space-y-1" data-id="element-369">
            {navItems.map(item => <Link key={item.name} to={item.path} onClick={() => setIsOpen(false)} className={`block px-3 py-3 rounded-lg text-base font-medium ${location.pathname === item.path ? 'bg-brand-50 text-brand-600' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-370">
                {item.name}
              </Link>)}
          </div>
        </motion.div>}
    </nav>;
}